import { PatentOrderingKey } from "@/components/business/PatentContainer/Patent.types";
import { invalidatePatentTableDataQuery } from "@api/patent/patentList/usePatentListFilter";

import { useHandlePatentTableOrdering } from "./hooks/useHandlePatentTableOrdering";
import * as S from "./PatentTableHead.style";
import {
  Ordering,
  TableHeaderList,
} from "../../constants/PatentTable.constants";

const PatentTableHead = () => {
  const { tableHeaderList, checkIsOrdering, getOrderingIcon, handleOrdering } =
    useHandlePatentTableOrdering();
  const updatePatentTableData = invalidatePatentTableDataQuery;

  const handleClickOrdering = (
    orderingTitle: PatentOrderingKey,
    ordering: Ordering,
  ) => {
    handleOrdering(orderingTitle, ordering);
    updatePatentTableData();
  };

  return (
    <S.PressListTableHead>
      <S.TableRow>
        {tableHeaderList.map((item: TableHeaderList) => (
          <S.TableHeadShell
            key={`thead-${item.orderingTitle}`}
            onClick={() =>
              handleClickOrdering(
                item.orderingTitle as PatentOrderingKey,
                item.ordering,
              )
            }
          >
            <S.TableHeadShellContents
              isOrdering={checkIsOrdering(item.ordering)}
            >
              <S.TableHeadShellTitle
                isOrdering={checkIsOrdering(item.ordering)}
              >
                {item.title.split("\n").map((word, wordIndex) => (
                  <S.TableHeadShellTitleWord key={word + String(wordIndex)}>
                    {word}
                  </S.TableHeadShellTitleWord>
                ))}
              </S.TableHeadShellTitle>

              <S.OrderingIconWrapper>
                {getOrderingIcon(item.ordering)}
              </S.OrderingIconWrapper>
            </S.TableHeadShellContents>
          </S.TableHeadShell>
        ))}
      </S.TableRow>
    </S.PressListTableHead>
  );
};

export default PatentTableHead;
